export default ["None", "OnlyMine", "MyGroups", "All"];